const CONSTANTS = {
  title: 'Sarthak Hive',
  user: {
    roles: {
      owner: 'Owner',
    },
  },
  party: {
    types: {
      customer: 'Customer',
      supplier: 'Supplier',
      manufacturer: 'Manufacturer',
      transporter: 'Transporter',
      employee: 'Employee',
      contact: 'Contact',
      other: 'Other',
    },
    paymentCategory: {
      partialAdvanceAndRestPDC: 'Partial Advance And Rest PDC',
      partialAdvanceAndRestBeforeDispatch:
        'Partial Advance And Rest Before Dispatch',
      advanceWithCashDiscount: 'Advance With Cash Discount',
      dispatchAfterPDC: 'Dispatch After PDC',
      selfTransferAfterDue: 'Self Transfer After Due',
      COD: 'Cash On Delivery',
      DOD: 'Draft On Delivery (DOD)',
      advance: 'Advance',
      credit: 'Credit',
    },
  },
  material: {
    types: {
      raw: 'Raw',
      packing: 'Packing',
      secondaryPacking: 'Secondary Packing',
      consumable: 'Consumable',
    },
    ingredientSpecification: {
      ip: 'I.P.',
      bp: 'B.P.',
      usp: 'U.S.P.',
      other: 'Other',
    },
    ingredientTypes: {
      Raw: {
        active: 'Active',
        excipient: 'Excipient',
        color: 'Color',
        coating: 'Coating',
        flavor: 'Flavor',
        fragrance: 'Fragrance',
        shell: 'Shell',
      },
      Packing: {
        printedInnerBox: 'Printed Inner Box',
        printedOuterBox: 'Printed Outer Box',
        printedFoil: 'Printed Foil',
        printedInsert: 'Printed Insert',
        label: 'Label',
        tube: 'Tube',
        bag: 'Bag',
        printedBox: 'Printed Box',
        waterForInjection: 'Water For Injection',
      },
      'Secondary Packing': {
        corrugatedBoxes: 'Corrugated Boxes',
        baseFoil: 'Base Foil',
        bottle: 'Bottle',
        cap: 'CAPS/CLOSURES/PLUG',
        pvc: 'PVC',
        tape: 'Tape',
        belt: 'Belt',
        dropper: 'Dropper',
        bag: 'Bag',
        wrap: 'Wrap',
        foil: 'Foil',
        box: 'Box',
        tray: 'Tray',
      },
      Consumable: {
        consumable: 'Consumable',
        cylinder: 'Cylinder',
        foilPrintingInks: 'Foil Printing Inks',
        leaveBehindLiterature: 'Leave Behind Literature',
        promotionalMaterial: 'Promotional Material',
        maintainance: 'Maintainance',
        lr: 'Laboratory Reagents',
        services: 'Services',
        uniformsAndProtectiveWear: 'Uniforms And Protective Wear',
        pantryAndRefreshments: 'Pantry And Refreshments',
        cleaningAndHousekeeping: 'Cleaning And Housekeeping',
        stationaryAndOfficeSupplies: 'Stationary And Office Supplies',
      },
    },
  },
  stockAdjustment: {
    types: {
      stockAdd: 'Stock Add',
      stockRemove: 'Stock Remove',
    },
  },
  product: {
    categories: {
      beta: 'Beta',
      nonBeta: 'Non Beta',
      food: 'Food',
      ayush: 'Ayush',
      finishedGoods: 'Finished Goods (Outsource)',
    },
    subcategories: {
      capsule: 'Capsule',
      liquid: 'Liquid',
      ointmentExternal: 'Ointment/External',
      tablet: 'Tablet',
      drySyrup: 'Dry Syrup',
      dustingPowder: 'Dusting Powder',
      sachet: 'Sachet',
      other: 'Other',
      finishedGoods: 'Finished Goods (Outsource)',
      soap: 'Soap',
    },
    specification: {
      ip: 'IP',
      bp: 'BP',
      usp: 'USP',
      other: 'Other',
    },
    testingParameter: {
      dt: 'DT',
      diso: 'DISO',
    },
    approvalStatus: {
      approved: 'Approved by DI Office',
      applied: 'Applied for',
      cancelled: 'Cancelled',
      reApplied: 'Re-Applied',
      notApplied: 'Not applied. Created for costing only',
    },
  },
  order: {
    types: {
      government: 'Government',
      export: 'Export',
      other: 'Other',
      thirdParty: 'Third Party',
    },
  },
  production: {
    coating: {
      sugar: 'Sugar',
      film: 'Film',
      enteric: 'Enteric',
    },
    sections: {
      capsule: 'Capsule',
      liquid: 'Liquid',
      ointmentExternal: 'Ointment/External',
      tablet: 'Tablet',
      drySyrup: 'Dry Syrup',
      dustingPowder: 'Dusting Powder',
      sachet: 'Sachet',
      other: 'Other',
    },
    departments: {
      ppic: 'PPIC',
      mdo: 'MDO',
      maintainance: 'Maintainance',
      sales: 'Sales',
      crm: 'CRM',
      dispatch: 'Dispatch',
      qualityAssurance: 'Quality Assurance',
      qualityControl: 'Quality Control',
      frontofficeReception: 'Front Office/Reception',
      accounts: 'Accounts',
      production: 'Production',
    },
  },
  machine: {
    sections: {
      liquid: 'Liquid',
      capsule: 'Capsule',
      rawMaterial: 'Raw Material',
      tablet: 'Tablet',
      packingNonBetaGF: 'Packing Non Beta (GF)',
      packingNonBetaFF: 'Packing Non Beta (FF)',
      coating: 'Coating',
      dustingPowder: 'Dusting Powder',
      ointmentExternal: 'Ointment/External',
      drySyrup: 'Dry Syrup',
      sachet: 'Sachet',
    },
    locations: {
      Liquid: {
        solutionPreparationRoom: 'Solution Preparation Room',
        liquidFIllingAndSealingRoom: 'Liquid Filling And Sealing Room',
        liquidPackingArea: 'Liquid Packing Area',
      },
      Capsule: {
        capsuleNonBetaGF: 'Capsule Non Beta (GF)',
        capsuleNonBetaFF: 'Capsule Non Beta (FF)',
      },
      'Raw Material': {
        rawMaterialNonBetaGF: 'Raw Material Non Beta (GF)',
        rawMaterialNonBetaFF: 'Raw Material Non Beta (FF)',
      },
      Tablet: {
        tabletNonBetaGF: 'Tablet Non Beta (GF)',
        tabletNonBetaFF: 'Tablet Non Beta (FF)',
      },
      'Packing Non Beta': {
        blisterMachineRoom: 'Blister Machine Room',
        aluAluMachineRoom: 'Alu-Alu Machine Room',
      },
      'Packing Non Beta (GF)': {
        aluAluMachineRoom: 'Alu-Alu Machine Room',
      },
      'Packing Non Beta (FF)': {
        aluAluMachineRoom: 'Alu-Alu Machine Room',
      },
      Coating: {
        coatingNonBetaGF: 'Coating Non Beta (GF)',
        coatingNonBetaFF: 'Coating Non Beta (FF)',
      },
      'Dusting Powder': {
        dustingPowderNonBetaGF: 'Dusting Powder Non Beta (GF)',
        dustingPowderNonBetaFF: 'Dusting Powder Non Beta (FF)',
      },
      'Ointment/External': {
        ointmentExternal: 'Ointment/External',
      },
      'Dry Syrup': { drySyrup: 'Dry Syrup' },
      Sachet: { sachet: 'Sachet' },
    },
  },
  invoice: {
    cancelReason: {
      1: 'Duplicate',
      2: 'Data entry mistake',
      3: 'Order Cancelled',
      4: 'Others',
    },
  },
  cdn: {
    types: {
      credit: 'Credit Note',
      debit: 'Debit Note',
    },
    reasons: {
      rateDiff: 'Rate Difference',
      quantityDiff: 'Quantity Difference',
      rejection: 'Quantity Rejection',
    },
  },
  enquiry: {
    types: {
      pcd: 'PCD',
      thirdParty: 'Third Party',
    },
  },
  bank: {
    summaryHeads: {
      directExpenses: 'Direct Expenses',
      indirectExpenses: 'Indirect Expenses',
      directIncomes: 'Direct Incomes',
      indirectIncomes: 'Indirect Incomes',
      otherIncome: 'Other Income',
      manufacturingExpenses: 'Manufacturing Expenses',
      capitalAccount: 'Capital Account',
      loans: 'Loans',
      otherLoans: 'Other Loans',
      currentLiabilities: 'Current Liabilities',
      fixedAssets: 'Fixed Assets',
      currentAssets: 'Current Assets',
      supplierPayment: 'Supplier Payment',
      customerPayment: 'Customer Payment',
    },
    transactions: {
      types: {
        expense: 'Expense',
        income: 'Income',
      },
      whom: {
        party: 'Party',
        contact: 'Contact',
        asset: 'Asset',
      },
    },
  },
  assets: {
    adjust: {
      increment: 'Increment',
      decrement: 'Decrement',
    },
  },
  contact: {
    types: {
      director: 'Director',
      partner: 'Partner',
      employee: 'Employee',
      other: 'Other',
    },
  },
  bill: {
    whom: {
      party: 'Party',
      contact: 'Contact',
    },
  },
  tasks: {
    repeat: {
      daily: 'daily',
      weekly: 'weekly',
      biWeekly: 'bi-weekly',
      monthly: 'monthly',
      customMonths: 'custom-months',
    },
    types: {
      task: 'task',
      event: 'event',
      reminder: 'reminder',
    },
  },
  leads: {
    category: {
      // nBDcRR: 'NBD CRR',
      nBDoUTCOMING: 'NBD Outgoing',
      nBDiNCOMING: 'NBD Incoming',
    },
    sources: {
      // 'NBD CRR': {
      //   self: 'Self',
      //   promptedForWalletShareOrCrossSell:
      //     'Prompted for wallet share or cross sell',
      // },
      'NBD Outgoing': {
        digitalPromotion: 'Digital Promotion',
        seo: 'SEO',
        telecalling: 'Tele Calling',
      },
      'NBD Incoming': {
        website: 'Website',
        referenceFromOthers: 'Reference from Others',
        promptedForWalletShareOrCrossSell:
          'Prompted for wallet share or cross sell',
      },
    },
    statuses: {
      open: 'Open',
      meeting: 'Meeting Done',
      quotation: 'Quotation Sent',
      converted: 'Converted',
      closed: 'Closed',
    },
  },
  interactions: {
    types: {
      call: 'Call',
      email: 'Email',
      virtualMeeting: 'Virtual Meeting',
      inPersonMeeting: 'In-Person Meeting',
    },
    outcomes: {
      Call: {
        noAnswer: 'No Answer',
        busy: 'Busy',
        wrongNumber: 'Wrong Number',
        leftVoicemail: 'Left Voicemail',
        connected: 'Connected',
        callMeAgain: 'Call Me Again',
        missed: 'Missed',
      },
      Email: {
        delivered: 'Delivered',
        wrongEmail: 'Wrong Email',
        deliveryFailure: 'Delivery Failure',
        spam: 'Spam',
      },
      'Virtual Meeting': {
        completed: 'Completed',
        rescheduled: 'Rescheduled',
        cancelled: 'Cancelled',
      },
      'In-Person Meeting': {
        attended: 'Attended',
        notAttended: 'Not Attended',
      },
    },
  },
  accounts: {
    transactions: {
      types: {
        Credit: 'Credit',
        Debit: 'Debit',
      },
      modes: {
        neft: 'NEFT',
        upi: 'UPI',
        rtgs: 'RTGS',
        imps: 'IMPS',
        Cash: 'Cash',
        Cheque: 'Cheque',
        ATM: 'ATM',
        Card: 'Card',
        ECS: 'ECS',
        eFundTransfer: 'e-Fund Transfer',
        ElectronicCheque: 'Electronic Cheque',
        ElectronicDDPO: 'Electronic DD/PO',
        Others: 'Others',
      },
      methodOfAdjustments: {
        Advance: 'Advance',
        AgstRef: 'Agst Ref',
        NewRef: 'New Ref',
        OnAccount: 'On Account',
      },
      invoiceTypes: {
        Sale: 'sales',
        'Credit Debit Note': 'credit_debit_notes',
        Purchase: 'purchases',
        'GST TDS Voucher': 'purchase_bills',
      },
    },
    taxability: {
      Exempt: 'Exempt',
      NilRated: 'Nil Rated',
      Taxable: 'Taxable',
    },
    supplyType: {
      Services: 'Services',
      Goods: 'Goods',
    },
    registrationType: {
      Regular: 'Regular',
      Unregistered: 'Unregistered',
      Consumer: 'Consumer',
      Composition: 'Composition',
    },
    deducteeType: {
      PartnershipFirm: 'Partnership Firm',
      LocalAuthority: 'Local Authority',
      IndividualHUFResident: 'Individual/HUF - Resident',
      IndividualHUFNonResident: 'Individual/HUF - Non Resident',
      Government: 'Government',
      CoOperativeSocietyResident: 'Co-Operative Society - Resident',
      CoOperativeSocietyNonResident: 'Co-Operative Society - Non Resident',
      CompanyResident: 'Company - Resident',
      CompanyNonResident: 'Company - Non Resident',
      BodyOfIndividuals: 'Body of Individuals',
      AssociationOfPersons: 'Association of Persons',
      ArtificialJuridicalPerson: 'Artificial Juridical Person',
    },
  },
  orderStatusConditions: {
    'Not authorized': {
      isAuthorized: 'false',
      isDeleted: 'false',
    },
    Authorized: {
      isAuthorized: 'true',
      isMovedToProductionPlanning: 'false',
      isInProduction: 'false',
      isDeleted: 'false',
    },
    'Full kitting pending and in production planning': {
      isAuthorized: 'true',
      isMovedToProductionPlanning: 'true',
      isInProduction: 'false',
      isDeleted: 'false',
    },
    'Move to Production': {
      isAuthorized: 'true',
      isMovedToProductionPlanning: 'true',
      isInProduction: 'false',
      isDeleted: 'false',
    },
    'Materials dispensed': {
      isAuthorized: 'true',
      isMovedToProductionPlanning: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Full kitting pending  ': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'All Material Available': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled BPR Yield Statement': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled BMR Yield Statement': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled Bulk Good COA': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled Finished Good COA': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled Coating Operation': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled In Process Control Sheet': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled Environment Monitoring Records': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled Manufacturing Statement': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled Check List Line Clearance': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Filled Cleaning Certificate': {
      isAuthorized: 'true',
      isInProduction: 'true',
      isDeleted: 'false',
    },
    'Ready For Dispatch': {
      isAuthorized: 'true',
      isReadyForDispatch: 'true',
      isDeleted: 'false',
    },
    'Sale Preparation': {
      isAuthorized: 'true',
      isSalePreparation: 'true',
      isDeleted: 'false',
    },
    'Ready For Sale': {
      isAuthorized: 'true',
      isReadyForSale: 'true',
      isDeleted: 'false',
    },
    Completed: {
      isAuthorized: 'true',
      isCompleted: 'true',
      isDeleted: 'false',
    },
    Deleted: {
      isDeleted: 'true',
    },
  },
  procurementFms: {
    materialTypes: {
      raw: 'Raw',
      packing: 'Packing',
      secondaryPacking: 'Secondary Packing',
      consumable: 'Consumable',
    },
    stageTAT: {
      rfqClosed: 18, // 2 working days (9h shift)
      poCreated: 9, // 1 working day (9h shift)
      poFileUpload: 1, // 1 working hour (Packing only)
      poAuthorize: 4, // 4 working hours
      purchaseInward: 4, // 4 working hours
      inwardToQuarantine: 4, // 4 working hours
      quarantineToSample: 1, // 1 working hour
      sampleToUnderTest: 1, // 1 working hour
      underTestToCOA: 18, // 2 working days (9h shift)
      coaToDecisionSlip: 1, // 1 working hour
      rejectionToDebitNote: 9, // 1 working day (9h shift)
    },
    vendorScorecard: {
      weights: {
        rfqResponsiveness: 0.2,
        onTimeDelivery: 0.25,
        qualityAcceptance: 0.35,
        priceAdherence: 0.1,
        priceStability: 0.1,
      },
      priceStabilityLookbackCount: 5,
      tiers: {
        tier1: { minScore: 90, label: 'Tier 1 - Preferred', color: 'green' },
        tier2: { minScore: 75, label: 'Tier 2 - Standard', color: 'blue' },
        tier3: { minScore: 60, label: 'Tier 3 - Monitoring', color: 'orange' },
        tier4: { minScore: 0, label: 'Tier 4 - High Risk', color: 'red' },
      },
    },
    alertThresholds: {
      overduePoDeliveryHours: 0,
      stalledRfqHours: 48,
      quarantinePendingHours: 8,
      qcTestingOverdueHours: 48,
      pendingDebitNoteHours: 24,
    },
  },
};

export default CONSTANTS;
